const part = [
    {
        path: 'commission-list',
        name: 'SaleStatList',
        meta: {
            icon: 'md-stats',
            title: '销售提成',
            notCache: false,
            access: ['S', 'A', 'B', 'C', 'D', 'I', 'G', 'I2', 'J', 'P'],
            items: [
            ]
        },
        component: () => import('@/view/finance-management/commission/commission-list')
    },
    {
        path: 'transaction-allocation-list',
        name: 'transaction-allocation-list',
        meta: {
            icon: 'ios-apps',
            title: '分账表',
            notCache: false,
            access: [ 'S' ],
            items: [
            ]
        },
        component: () => import('@/view/sale-management/sale-stat/transaction-allocation-list.vue')
    }
];

export default part;
